export enum Service {
  GATEWAY,
  ECM,
  ECW,
  CORRESPONDENCE,
}

export default Service;
